export enum CookiesEnum {
	firstVisit = 'firstVisit',
	pinnedLeagues = 'pinnedLeagues',
}
